<template>
  <div v-if="mobileWeb" :class="['rfmodal-footer-mobileweb', { 'rfmodal-footer--tour': isTour }]">
    <div
      v-if="confirmationText"
      class="rfmodal-done-icon"
      :style="{ color: actions.rf_settings_fill_color }"
    >
      <span class="success-message-div" v-html="confirmationText"></span>
    </div>
    <template v-else>
      <RfRetentionButtonsInner
        :model="model"
        :actions="actions"
        :isNewDeviceEditor="isNewDeviceEditor"
        :acceptButtonEnabled="acceptButtonEnabled"
        :newButtonStyles="newButtonStyles"
        @onAccept="onAccept"
        @onDecline="onDecline"
      />
      <RfPromptTimeout v-if="!isNewDeviceEditor" :actions="actions" mobileWeb />
    </template>
  </div>
  <div v-else :class="['rf-button-wrapper', { 'rfmodal-footer--tour': isTour }]">
    <div
      v-if="confirmationText"
      class="rfmodal-done-icon"
      :style="{ color: actions.rf_settings_fill_color }"
    >
      <span class="success-message-div" v-html="confirmationText"></span>
    </div>
    <template v-else>
      <div class="rf-buttons-inner">
        <RfRetentionButtonsInner
          :model="model"
          :actions="actions"
          :isNewDeviceEditor="isNewDeviceEditor"
          :acceptButtonEnabled="acceptButtonEnabled"
          :newButtonStyles="newButtonStyles"
          @onAccept="onAccept"
          @onDecline="onDecline"
        />
      </div>
      <RfPromptTimeout v-if="!(isNewDeviceEditor || newTimeout)" :actions="actions" />
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import RfRetentionButtonsInner from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionButtonsInner.vue";
import RfPromptTimeout from "./RfPromptTimeout.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

const props = defineProps({
  model: { type: Object, default: null },
  actions: { type: Object, default: null },
  mobileWeb: { type: Boolean, default: false },
  isNewDeviceEditor: { type: Boolean, default: false },
  newTimeout: { type: Boolean, default: false },
  acceptButtonEnabled: { type: Boolean, default: true },
  newButtonStyles: { type: Boolean, default: false },
});

const liquidContextStore = useLiquidContextStore();

const modalAccepted = ref(false);
const modalDeclined = ref(false);

const isTour = computed(() => props.model?.sequence_type === "tour");

const confirmationText = computed(() => {
  if (modalAccepted.value)
    return liquidContextStore.liquidify(props.actions?.rf_retention_acceptance_text ?? "");
  if (modalDeclined.value)
    return liquidContextStore.liquidify(props.actions?.rf_retention_decline_text ?? "");
  return "";
});

function onAccept() {
  if (props.actions?.rf_retention_acceptance_text) {
    modalDeclined.value = false;
    modalAccepted.value = true;
  }
}

function onDecline() {
  if (props.actions?.rf_retention_decline_text) {
    modalAccepted.value = false;
    modalDeclined.value = true;
  }
}

watch(
  () => props.actions?.rf_retention_acceptance_text,
  text => {
    if (!text) modalAccepted.value = false;
  },
);

watch(
  () => props.actions?.rf_retention_decline_text,
  text => {
    if (!text) modalDeclined.value = false;
  },
);
</script>

<style scoped>
.rfmodal-done-icon {
  font-size: inherit;
  margin-left: 0;
}
.success-message-div {
  display: block;
  font-size: 16px;
  padding: 10px 0;
  text-align: left;
}
</style>
